import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { ReportType } from '@ddt-web/pdf-utils';
import * as get from 'lodash/get';

import { DisclosureComponent } from '../../disclaimers/disclosure-component';
import { HeadingComponent, HeadingLevel } from '../../heading/heading-component';
import { FundPerformancePanelsHelper } from '../../helpers/fund-performance/fund-performance-panels-helper';

export class StandardizedPerformanceMarketComponent extends BusinessComponent {
	private stdPerfMarketTab: TabData;

	constructor(name: string, public dataComponentId: string, private mode?: ReportType, private shouldReduceSpacing: boolean = false, public visible: boolean = true) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const isComponentDataSuccessful = componentData && componentData.success;
		this.stdPerfMarketTab = isComponentDataSuccessful && get(componentData, 'tabs[2]');

		return TabUtil.isTabValid(this.stdPerfMarketTab);
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisible(componentData)) {

			return [
				new HeadingComponent('PDF_QUART_RET_H3', 'QUARTERLY RETURNS - MARKET(%)**', HeadingLevel.H3),
				...FundPerformancePanelsHelper.getAsOfDatePanel(this.stdPerfMarketTab, {}, this.shouldReduceSpacing),
				...FundPerformancePanelsHelper.getFundPerformancePanels(this.stdPerfMarketTab, contentSvc, {}, this.mode, this.shouldReduceSpacing),
				new DisclosureComponent('PDF_QUART_RET_DISCLAIMER_1', '* Annualized', {}, { paddingTop: 15 }),
				new DisclosureComponent('PDF_QUART_RET_DISCLAIMER_2', '** For ETFs and Closed End Funds only', {}, { paddingBottom: 20 })
			];
		}
		return [];
	}
}
